import translate from "./translate";

const truncateToFixedHeight = node => {
  const nodeHeight = node.offsetHeight;
  const textNode = node.childNodes[0];

  while (textNode && textNode.offsetHeight > nodeHeight) {
    const updatedText = textNode.textContent.replace(
      /(\W*\s\S*$)|^\S*$/,
      "..."
    );

    if (updatedText === textNode.textContent) {
      break;
    }

    textNode.innerHTML = updatedText;

    if (textNode.textContent === "...") {
      break;
    }
  }

  node.classList.add("js-truncated");
};

const truncateToFluidHeight = (node, bottomEdge) => {
  let nodeRect = node.getBoundingClientRect();
  let stopTruncation = false;
  let success = true;

  const textNode = node.querySelector(".tile__text");
  if (!textNode) return false;

  while (nodeRect.bottom > bottomEdge) {
    if (textNode.offsetHeight <= 19.2 || textNode.textContent === "...") { // 19.2 stands for text line height
      stopTruncation = true;
    }

    if (stopTruncation) {
      success = false;
      break;
    } else {
      const updatedText = textNode.textContent.replace(
        /(\W*\s\S*$)|^\S*$/,
        "..."
      );

      if (updatedText === textNode.textContent) {
        break;
      }

      textNode.innerHTML = updatedText;

      nodeRect = node.getBoundingClientRect();
    }
  }

  node.classList.add("js-truncated");
  return success;
};

const responsiveFixedRatioTiles = container => {
  container.classList.remove("mini");

  const textWrapperNodes = container.querySelectorAll(
    ".tile__text-wrapper:not(.js-truncated)"
  );

  for (let i = 0; i < textWrapperNodes.length; i += 1) {
    truncateToFixedHeight(textWrapperNodes[i]);
  }
};

const responsiveFluidTiles = container => {
  const contentNodes = container.querySelectorAll(
    ".tile__promotion-content:not(.js-truncated)"
  );

  if (!contentNodes.length) return;

  let contentNodesTruncationSuccess = true;

  const tile = container.querySelector(".tile");
  const tileRect = tile.getBoundingClientRect();
  const tileBottom = tileRect.bottom;

  for (let i = 0; i < contentNodes.length; i += 1) {
    const success = truncateToFluidHeight(contentNodes[i], tileBottom);

    if (!success) {
      contentNodesTruncationSuccess = false;
    }
  }

  if (!contentNodesTruncationSuccess) {
    container.classList.add("mini");
  }
};

const uploadImg = _node => {
  const node = _node;
  const img = new window.Image();
  const src = node.getAttribute("data-img");

  if (typeof src !== "undefined" && src !== null && src.length > 0) {
    img.onload = () => {
      node.innerHTML = "";
      node.style.backgroundImage = `url("${src}")`;
      node.removeAttribute("data-img");
    };

    img.src = src;
  } else {
    node.innerHTML = "";
  }
};

export default class Templater {
  constructor(options = {}) {
    this.options = {
      mainColor: "#8d2c78",
      landingPageUrl: "",
      contactsEnabled: true,
      ...options
    };

    if (!this.options.hexToRgba)
      throw new Error("no hexToRgba implementation found");
  }

  noItemsBlock() {
    const { landingPageUrl, contactsEnabled } = this.options;

    const node = document.createElement("article");
    node.classList.add("main-tiles__unit");
    node.classList.add("empty");
    if (!contactsEnabled) {
      node.classList.add("contacts-disabled");
    }

    node.innerHTML = `<div class="tile one-block">
      <div>
        <div class="tile__placeholder">
          <div class="tile__placeholder-img">
            <image src="/contact-us.svg" alt="" />
          </div>
          <p>
            ${translate("empty_slide_message")}
          </p>
          ${
            !landingPageUrl
              ? ""
              : `<a href="${landingPageUrl}" target="_blank" class="tile__placeholder-button">${translate(
                  "contact_us_button_text"
                )}<span class="visually-hidden">${translate("opens_in_new_window")}</span></a>`
          }
        </div>
      </div>
    </div>`;

    return node;
  }

  tile(data) {
    if (!data) return null;
    const {
      mainColor,
      landingPageUrl,
      hexToRgba,
      contactsEnabled,
      newspaperName
    } = this.options;

    const tileNode = document.createElement("article");
    tileNode.classList.add("main-tiles__unit");

    if (!data.id) {
      tileNode.classList.add("empty");
      if (!contactsEnabled) {
        tileNode.classList.add("contacts-disabled");
      }

      tileNode.innerHTML = `<div class="tile">
        <div>
          <div class="tile__placeholder">
            <div class="tile__placeholder-img">
              <image src="/contact-us.svg" alt="" />
            </div>
            <p>
              ${translate("empty_slide_message")}
            </p>
            ${
              !landingPageUrl
                ? ""
                : `<a href="${landingPageUrl}" target="_blank" class="tile__placeholder-button">${translate(
                    "contact_us_button_text"
                  )}<span class="visually-hidden">${translate("opens_in_new_window")}</span></a>`
            }
          </div>
        </div>
      </div>`;
    } else if (data.coupon_enabled) {
      const couponUrl = `/promotions/${data.id}/coupon.pdf`;
      const couponDiscount = `${data.discount}%`;
      const couponDiscountPrevPrice = data.prev_price
        ? `${data.prev_price} ${translate("discount_currency")}`
        : "";
      const couponDiscountCurrentPrice = data.current_price
        ? `${data.current_price} ${translate("discount_currency")}`
        : "";

      tileNode.innerHTML = `
      <div class="tile">
        <div class="tile__wrapper">
          <div class="tile__img-wrapper discount__img-wrapper">
            <a href="${data.link || "javascript:void(0)"}" data-id="${
        data.id
      }" target="_blank" tabindex="-1">
              <div class="tile__img" data-img="${data.image ? data.image : ""}">
                <div class="tile__img-loader"></div>
              </div>
              <div class="discount__thumb">
                <span class="discount__amount">${couponDiscount}</span>
                <span class="discount__help_text">${translate(
                  "discount_help_text"
                )}</span></div>
              ${
                data.prev_price || data.current_price
                  ? `<div class="discount__price-wrapper">
                ${
                  data.current_price
                    ? `<span class="discount__current-price">${couponDiscountCurrentPrice}</span>`
                    : ""
                }
                ${
                  data.prev_price
                    ? `<span class="discount__prev-price">${couponDiscountPrevPrice}</span>`
                    : ""
                }
              </div>`
                  : ""
              }
              
            </a>
          </div>
          <div class="get-discount-wrapper">
              <a href="${couponUrl}" target="_blank" id="${
        data.id
      }" data-customer="${
        data.customer.name
      }" data-newspaper="${newspaperName}" class="discount-link discount__link">${translate(
        "download_coupon_button"
      )}
                <svg width="7px" height="10px" viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(-219.000000, -11.000000)" fill="#FFFFFF" fill-rule="nonzero">
                          <g transform="translate(222.000000, 16.000000) rotate(-360.000000) translate(-222.000000, -16.000000) translate(212.000000, 6.000000)">
                              <path d="M11.3214887,10 L7.74407768,13.577411 C7.41864077,13.9028479 7.41864077,14.4304854 7.74407768,14.7559223 C8.06951459,15.0813592 8.59715207,15.0813592 8.92258898,14.7559223 L13.0892557,10.5892557 C13.4146926,10.2638187 13.4146926,9.73618126 13.0892557,9.41074435 L8.92258898,5.24407768 C8.59715207,4.91864077 8.06951459,4.91864077 7.74407768,5.24407768 C7.41864077,5.56951459 7.41864077,6.09715207 7.74407768,6.42258898 L11.3214887,10 Z" id="Path-10"></path>
                          </g>
                      </g>
                  </g>
                </svg>
              </a>
          </div>
          <a href="${data.link || 'javascript:void(0)'}" data-id="${
        data.id
      }" target="_blank" class="discount__promotion-link">
            <div class="tile__content tile__promotion-content">
              <div class="tile__content-header">
                <h2 class="tile__title">
                  ${data.customer ? data.customer.name : ""}
                </h2>
              </div>
              <div class="tile__text-wrapper"><p class="tile__text">${data.message ||
                data.description}</p></div>
            </div>
            <span class="visually-hidden">${translate("opens_in_new_window")}</span>
          </a>
        </div>
    </div>`;
    } else {
      const isVideo = data.media_type === "video";
      const isPortrait = (data?.image_height && data?.image_width) ? data.image_height > data.image_width : false;

      tileNode.innerHTML = `<a href="${data.link ||
        "javascript:void(0)"}" data-id="${
        data.id
      }" target="_blank" class="tile">
        <div>
          <div class="tile__wrapper">
            <div class="tile__img-wrapper ${isPortrait ?"tile__img-wrapper-portrait" : ""}">
              <div class="tile__img ${isPortrait ?"tile__img-portrait" : ""}" data-img="${data.image || data.small_image || ""}">
                <div class="tile__img-loader"></div>   
              </div>
              ${isVideo ? '<div class="tile__play-button"></div>' : ""}
            </div>
            <div class="tile__content tile__promotion-content ${isPortrait ? "tile__content-portrait" : ""}">
              <div class="tile__content-header">
                ${data.customer && data.customer.display_logo && data.customer.logo_thumb_url ? `
                <div class="tile__logo">
                  <img alt="${data.customer.name}" src="${data.customer.logo_thumb_url}" />
                </div>
                ` : ""}
                ${data.customer && data.customer.name ? `
                  <h2 class="tile__title">
                    ${data.customer.name}
                  </h2>
                ` : ""}
              </div>
              <div class="tile__text-wrapper"><p class="tile__text">${data.message ||
                data.description}</p></div>
            </div>
          </div>
        </div>
        <span class="visually-hidden">${translate("opens_in_new_window")}</span>
      </a>`;
    }

    return tileNode;
  }

  static loadingBlock() {
    return `<div class="main-tiles__unit">
      <div class="spinner-wrapper">
        <div class="spinner">
          <div class="spinner__bounce1"></div>
          <div class="spinner__bounce2"></div>
          <div class="spinner__bounce3"></div>
        </div>
      </div>
    </div>`;
  }

  static setTilesResponsiveness(container, isFrameHeightSet) {    
    if (isFrameHeightSet) {
      responsiveFluidTiles(container);
    } else {
      responsiveFixedRatioTiles(container);
    }
  }

  static resetTilesResponsiveness(container) {
    container.classList.remove("mini");
    const contentNodes = container.querySelectorAll(".tile__promotion-content");

    for (let i = 0; i < contentNodes.length; i++) {
      contentNodes[i].classList.remove("js-truncated");
    }
  }

  static uploadImages(container) {
    const imagesNodes = container.querySelectorAll(".tile__img[data-img]");

    for (let i = 0; i < imagesNodes.length; i += 1) {
      uploadImg(imagesNodes[i]);
    }
  }
}
